export const INSTRUCTION_SEPARATOR = '.,'
